require ('../node_modules/jquery-validation/dist/jquery.validate.min')
let autosize = require ('../node_modules/autosize/dist/autosize.min')


function checkInputValue(selector) {
    let $this = $(selector)

    if ( $this.val() ) {
        $this.addClass('used')
    } else {
        $this.removeClass('used')
    }

}


jQuery.validator.addMethod('emailfull', function(value, element) {
    return this.optional(element) || /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/.test(value)
}, 'Zadejte platný e-mail')


$(".send-message").on("click", function () {

    $.fancybox.open({
        src: '#contact-modal',
        touch: {
            vertical: false
        },
        modal: true,
        afterLoad: function () {

            autosize($('textarea'));

            $('input, textarea').each(function() {
                let $this = $(this)
                checkInputValue($this)

                $this.blur(() => {
                    checkInputValue($this)
                })
            })

        },
        afterClose: function () {
            $('.form-sent').hide()
            $('.contact-form, .fancybox-btn-close').show()
            $('.contact-form .btn').removeClass('in-progress').find('em').text('Odeslat')
            $("#contact-form")[0].reset();
        }
    });

});


$('.contact-form').validate({
    rules: {
        email: {
            required: true,
            emailfull: true
        },
        message: {
            minlength: 10
        }
    },
    messages: {
        email: 'Zadejte platný e-mail',
        message: {
            required: 'Napište zprávu',
            minlength: 'Zadejte alespoň {0} znaků'
        }
    },
    errorPlacement: function (error, element) {
        if (element.is('[type="checkbox"]')) {
            element.parent('label').parent('fieldset').append(error)
        } else {
            element.parent().addClass('error').after(error)
        }
        error.wrapAll('<div class=\'typo-b4\'>')
    },
    highlight: function(element) {
        if (!$(element).is('[type="checkbox"]')) {
            $(element).parent().removeClass('valid').addClass('error')
        }

    },
    unhighlight: function(element) {
        if (!$(element).is('[type="checkbox"]')) {
            $(element).parent().removeClass('error').addClass('valid')
        }

    },
    success: function(element){
        element.closest('fieldset').find('.group').addClass('valid')
    },
    submitHandler: () => {

        let $this = $('#contact-form')

        var formContactData = $this.serialize();
        $this.find('.btn').addClass('in-progress').find('em').text('Odesílám...')
        $this.prev('[data-fancybox-close]').hide()

        $.ajax({
            type: 'POST',
            url: '../contact-send.php',
            data: formContactData,
        }).done(function (contactResponse) {

            var contactData = $.parseJSON(contactResponse);

            if (contactData.status === "success") {

                $this.hide()
                $this.next('.form-sent').fadeIn()

            } else if (contactData.status === "required-error") {
                $this.find('.btn em').text('Odeslat')
                $this.prev('[data-fancybox-close]').show()
                $(".contact-form span.error").remove();
                $(".contact-form *[name]").removeClass("error");

                $(".contact-form ." + contactData.element).append("<span class='error'>" + contactData.message + "</span>");
                $("." + contactData.element).find("*[name='" + contactData.element + "']").addClass("error");
            }

        });

    }
})
